const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

/** True for a site-relative path (`/cars`), never a protocol-relative one (`//evil`). */
export function isInternalPath(href: string): boolean {
  return href.startsWith('/') && !href.startsWith('//');
}

/**
 * Returns the href if it is safe to render in a link, otherwise null. Blocks
 * `javascript:`, `data:` and anything else that is not a known web protocol.
 */
export function safeHref(href: string): string | null {
  if (isInternalPath(href)) return href;
  try {
    return SAFE_PROTOCOLS.has(new URL(href).protocol) ? href : null;
  } catch {
    return null;
  }
}
